'use client'

import { X } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

const BANNER_DISMISSED_KEY = 'onautopilot-beta-banner-dismissed'

export function BetaBanner() {
	const [isDismissed, setIsDismissed] = useState<boolean | null>(null)
	const t = useTranslations('betaBanner')

	useEffect(() => {
		const dismissed = localStorage.getItem(BANNER_DISMISSED_KEY)
		setIsDismissed(dismissed === 'true')
	}, [])

	const handleDismiss = () => {
		setIsDismissed(true)
		localStorage.setItem(BANNER_DISMISSED_KEY, 'true')
	}

	// Don't render anything until we know the state
	if (isDismissed === null || isDismissed) {
		return null
	}

	return (
		<div className="sticky top-0 z-10000 w-full bg-[#2a2d32] px-4 py-2 text-center text-sm text-white">
			<span>
				{t('message')}{' '}
				<a
					href="https://x.com/onautopilotfi"
					target="_blank"
					rel="noopener noreferrer"
					className="text-white underline hover:text-white/80"
				>
					X
				</a>
			</span>
			<button
				type="button"
				onClick={handleDismiss}
				className="-translate-y-1/2 absolute top-1/2 right-4 rounded p-1 text-muted-foreground transition-colors hover:bg-white/10 hover:text-white"
				aria-label="Dismiss"
			>
				<X className="h-4 w-4" />
			</button>
		</div>
	)
}
